import { SxProps, Theme } from '@mui/material/styles';
import { colorPalette } from 'stylesheet';

type StyledCircularProgressProps = { position: 'absolute' | 'static' };

export const getCircularProgressSx = ({
  position,
}: StyledCircularProgressProps): SxProps<Theme> => ({
  position: position,
  '&.MuiCircularProgress-colorPrimary': {
    color: colorPalette.primary,
  },
});
